import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs").then(({ data }) => { setLogs(data); setLoading(false); });
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <header>
        <div className="label-small text-blue-700">Compliance</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 mt-1" style={{ fontFamily: "Manrope" }}>Audit Logs</h1>
        <p className="text-sm text-slate-600 mt-1">Immutable record of all user actions for ISO 27001 compliance.</p>
      </header>

      <div className="flat-card">
        <table className="data-table">
          <thead><tr><th>Timestamp</th><th>User</th><th>Action</th><th>Entity</th><th>Entity ID</th><th>IP</th></tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={6} className="text-center py-6 text-slate-500">Loading…</td></tr> :
              logs.length === 0 ? <tr><td colSpan={6} className="text-center py-6 text-slate-500">No logs.</td></tr> :
                logs.map((l) => (
                  <tr key={l.id}>
                    <td className="text-xs font-mono text-slate-600">{new Date(l.created_at).toLocaleString()}</td>
                    <td className="font-semibold text-slate-900">{l.username || "—"}</td>
                    <td><span className="label-small text-blue-700">{l.action}</span></td>
                    <td>{l.entity}</td>
                    <td className="text-xs font-mono text-slate-500">{(l.entity_id || "—").slice(0, 8)}</td>
                    <td className="text-xs text-slate-500">{l.ip || "—"}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
